import React, { useEffect, useCallback, useRef, useState } from "react";
import dayjs from "dayjs";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";

import {
  Grid,
  TextField,
  Autocomplete,
  IconButton,
  Button,
  Chip,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";

import { useSnackBar } from "src/context/SnackBarContext";
import {
  RESET_QUOTATION_HEAD,
  UPDATE_QUOTATION_HEAD,
} from "../slice/QuotationData";
import useFetchData from "src/views/utilities/useFetchData";
import Loadable from "src/layouts/full/shared/loadable/Loadable";
import { postData } from "src/views/utilities/api";
import { handleKeyDown } from "src/views/utilities/enetrFunction";

import {
  ADD_QUOTATION_TABLE_ROW,
  REPLACE_QUOTATION_TABLE,
  RESET_QUOTATION_TABLE,
} from "../slice/QuotationTable";
import History from "./History";
import Loader from "src/components/Loader";

function Header({ toDefault }) {
  const location = useLocation();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const { showSnackbar } = useSnackBar();
  const { data, isLoading, error } = useFetchData(
    ["masterData"],
    ["/api/getMasterDataQuotationBill"]
  );
  const headerData = useSelector((state) => state.quotationMaster);
  // const displayName = headerData?.name || headerData?.party?.name || "";

  const dispatch = useDispatch();
  const [maxbill, setMaxBill] = useState(0);
  const nextFieldRef = useRef(null);

  const params = new URLSearchParams(location.search);
  const dataString = params.get("data");

  // Unconditional declaration of `setDefaultData`
  const setDefaultData = useCallback(() => {
    //  find cash party
    const getCashParty = data?.masterData?.data?.customer_list.find(
      (item) => item.label === "3"
    );

    // find loged in user
    const getStaff = data?.masterData?.data?.employee_list.find(
      (item) =>
        item.label === data?.masterData?.data?.current_employee_name || ""
    );
    //  setting max of the bill no
    setMaxBill(data?.masterData?.data?.max_bill_no);
    dispatch(
      UPDATE_QUOTATION_HEAD({
        party: getCashParty,
        name: getCashParty?.name || "",
        staff: getStaff,
        taxPerc: data?.masterData?.data?.tax_perc,
        billNo: data?.masterData?.data?.max_bill_no,
        date: dayjs().format(),
        note: "",
        orderNo: 0,
        total: 0,
        discPerc: 0,
        discPercAmt: 0,
        discAmt: 0,
        taxAmt: 0,
        otherChg: 0,
        netTotal: 0,
        receiptAmt: 0,
        cashP: "",
        totalQty: 0,
        balance: 0,
        id: null,
      })
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.masterData?.data, dispatch, toDefault]);

  // Ensure `useEffect` is not conditional
  useEffect(() => {
    setLoading(true);
    dispatch(RESET_QUOTATION_TABLE());
    dispatch(RESET_QUOTATION_HEAD());
    if (data?.masterData?.data) {
      setDefaultData();
    }
    setLoading(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data?.masterData?.data, setDefaultData, toDefault]);

  // Get data from order section
  useEffect(() => {
    // Decode and parse JSON
    const dataArray = dataString
      ? JSON.parse(decodeURIComponent(dataString))
      : [];
    if (dataArray?.length > 0) {
      if (dataArray[0]?.party) {
        const findParty = data?.masterData?.data?.customer_list.find(
          (item) => item?.label === dataArray[0]?.party
        );

        dispatch(
          UPDATE_QUOTATION_HEAD({
            party: findParty,
            name: findParty?.name || "",
            orderNo: dataArray[0]?.orderNo,
          })
        );
      }
      dispatch(REPLACE_QUOTATION_TABLE(dataArray));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataString, data?.masterData?.data]);

  // initial loader
  if (isLoading) return <Loadable />;
  if (error)
    return (
      <>
        <Loadable />
        <p>Error: {error.message}</p>
      </>
    );
  // get data by bill no
  const getBillToUpdate = async (billNo = headerData.billNo) => {
    try {
      setLoading(true);
      const getData = await postData("/api/getBillToUpdateQuotationBill", {
        BillNo: billNo,
      });

      if (getData.success) {
        if (getData.data[0][0]) {
          const findParty = data?.masterData?.data?.customer_list.find(
            (item) => item?.label === getData.data[0][0]?.party
          );
          const findStaff = data?.masterData?.data?.employee_list.find(
            (item) => item?.label === getData.data[0][0]?.staff
          );
          const findBranch = data?.masterData?.data?.branch_list.find(
            (item) => item?.label === getData.data[0][0]?.branch
          );
          console.log(getData.data[0][0],"getData.data[0][0]getData.data[0][0]getData.data[0][0]");
          const bill_date=dayjs(getData.data[0][0]?.date)
          const del_date=dayjs(getData.data[0][0]?.del_date)
          const headerData = {
            ...getData.data[0][0],
            deliveryDate:del_date,
            party: findParty,
            staff: findStaff,
            delivery_days:Math.abs(parseInt(bill_date.diff(del_date,"day"))),
            branch: findBranch,
            receiptType:getData.data[0][0]?.ReceiptType
          };
          console.log(dayjs(bill_date).diff(dayjs(del_date,"day")),"dayjs(bill_date).diff(dayjs(del_date,))");
          
          getPartyBalance(findParty);
          getReceipt(billNo);
          dispatch(UPDATE_QUOTATION_HEAD(headerData));
          dispatch(REPLACE_QUOTATION_TABLE(getData.data[1].map((itx)=>({...itx,deliveryDate:dayjs(itx.exp_date)}))));
          dispatch(ADD_QUOTATION_TABLE_ROW());
        } else {
          dispatch(
            UPDATE_QUOTATION_HEAD({
              date: dayjs().format(),
              note: "",
              orderNo: 0,
              total: 0,
              discPerc: 0,
              discPercAmt: 0,
              discAmt: 0,
              taxAmt: 0,
              otherChg: 0,
              netTotal: 0,
              receiptAmt: 0,
              cashP: "",
              totalQty: 0,
              balance: 0,
              id: null,
            })
          );
          dispatch(RESET_QUOTATION_TABLE());
        }
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };
  // All input field handle
  const handleFieldChange = (field, value) => {
    dispatch(
      UPDATE_QUOTATION_HEAD({
        [field]: value,
      })
    );
  };
  const handleDateChange = (value) => {
    dispatch(
      UPDATE_QUOTATION_HEAD({
        date: dayjs(value).format(),
      })
    );
  };
  const handleDelDateChange = (value) => {
    dispatch(
      UPDATE_QUOTATION_HEAD({
        deliveryDate: dayjs(value).format(),
      })
    );
  };

  //  handle party change and get party's balance
  const handleParty = async (event, value) => {
    setDefaultData();
    dispatch(RESET_QUOTATION_TABLE());
    dispatch(
      UPDATE_QUOTATION_HEAD({
        party: value,
        name: value?.name || "",
      })
    );

    getPartyBalance(value);
  };
  const getReceipt = async (value) => {
    const receipt = await postData("/api/getReceiptByBillNo", {
      BillNo: value,
    });
    dispatch(
      UPDATE_QUOTATION_HEAD({
        receiptType: receipt?.data.ReceiptType || "",
        bankName: receipt?.data.PartyName || "",
      })
    );
  };
  const getPartyBalance = async (value) => {
    setLoading(true);
    try {
      const balanceAmt = await postData("/api/getBalanceByPartyName", {
        PartyName: value.label,
      });
      dispatch(
        UPDATE_QUOTATION_HEAD({
          balance: balanceAmt?.data.balance || 0,
        })
      );
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handlePhoneNo = (e) => {
    handleFieldChange("name", e.target.value);
  };

  // handle Click enter on the contact section get party name
  const handleEnterOnContact = (e) => {
    if (e.key === "Enter" && headerData?.contact) {
      const findParty = data?.masterData?.data?.customer_list.find(
        (item) => item?.phone === headerData?.contact
      );

      if (findParty) {
        dispatch(
          UPDATE_QUOTATION_HEAD({
            party: findParty,
            name: findParty?.name || e.target.value,
          })
        );
      } else {
        showSnackbar("warning", "Party can't find on this contact number");
      }
    }
  };

  const handleEnterOnBillNo = async (e) => {
    if (e.key === "Enter") {
      getBillToUpdate(headerData.billNo);
      handleKeyDown(e);
    }
  };

  //  Bill no increment function also getting bill data from the api
  const handleIncrement = () => {
    const value = headerData.billNo + 1;
    dispatch(
      UPDATE_QUOTATION_HEAD({
        billNo: value,
      })
    );
    if (headerData.billNo + 1 !== maxbill) {
      getBillToUpdate(headerData.billNo + 1);
    } else {
      dispatch(
        UPDATE_QUOTATION_HEAD({
          date: dayjs().format(),
          note: "",
          orderNo: 0,
          branch: null,
          staff: null,
          party: null,
          total: 0,
          discPerc: 0,
          discPercAmt: 0,
          discAmt: 0,
          taxAmt: 0,
          otherChg: 0,
          netTotal: 0,
          receiptAmt: 0,
          cashP: "",
          totalQty: 0,
          balance: 0,
          id: null,
        })
      );
      dispatch(RESET_QUOTATION_TABLE());
    }
  };

  //  Bill no decrement function also getting bill data from the api
  const handleDecrement = () => {
    const value = headerData.billNo - 1;
    dispatch(
      UPDATE_QUOTATION_HEAD({
        billNo: value,
      })
    );
    getBillToUpdate(headerData.billNo - 1);
  };

  const handleDialogOpen = () => setIsDialogOpen(true);
  const handleDialogClose = () => setIsDialogOpen(false);

  
  return (
    <>
      <Loader start={loading} />
      {/* Order history dialog */}
      <History
        open={isDialogOpen}
        onClose={handleDialogClose}
        getBillToUpdate={getBillToUpdate}
      />
      {/* header buttons */}
      <Grid container spacing={1} onKeyDown={handleKeyDown} alignItems="center">
        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <Autocomplete
            autoFocus
            size="small"
            fullWidth
            options={data?.masterData?.data?.customer_list}
            value={headerData.party}
            getOptionLabel={(option) => `${option.label}-${option.name}`}
            onChange={handleParty}
            renderInput={(params) => <TextField {...params} label="Party" />}
          />
        </Grid>
        <Grid item xs={6} sm={4.5} md={3.5} lg={2.5} xl={1.5}>
          <TextField
            label="Bill No"
            fullWidth
            size="small"
            name="billNo"
            value={headerData.billNo}
            onKeyDown={handleEnterOnBillNo}
            variant="outlined"
            inputProps={{
              min: 0,
              max: maxbill,
              style: { textAlign: "center" },
            }}
            ref={nextFieldRef}
            onChange={(e) => handleFieldChange("billNo", e.target.value)}
            InputProps={{
              startAdornment: (
                <IconButton
                  color="primary"
                  onClick={handleDecrement}
                  disabled={headerData.billNo === 0}
                >
                  <RemoveCircleIcon />
                  {/* <Icon icon="zondicons:minus-solid" /> */}
                </IconButton>
              ),
              endAdornment: (
                <IconButton
                  disabled={headerData.billNo === maxbill}
                  color="primary"
                  onClick={handleIncrement}
                >
                  <AddCircleIcon />
                  {/* <Icon icon="octicon:feed-plus-16" /> */}
                </IconButton>
              ),
            }}
          />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Date"
              format="DD/MM/YYYY"
              onChange={(value) => handleDateChange(value)}
              value={dayjs(headerData.date)}
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                },
              }}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <Autocomplete
            size="small"
            fullWidth
            disablePortal
            options={data?.masterData?.data?.branch_list}
            onChange={(e, value) => handleFieldChange("branch", value)}
            value={headerData.branch}
            renderInput={(params) => <TextField {...params} label="Branch" />}
          />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <Autocomplete
            size="small"
            fullWidth
            options={data?.masterData?.data?.employee_list}
            value={headerData.staff}
            onChange={(e, value) => handleFieldChange("staff", value)}
            renderInput={(params) => <TextField {...params} label="Staff" />}
          />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <TextField
            label="Order No"
            fullWidth
            size="small"
            name="orderNo"
            value={headerData.orderNo}
            variant="outlined"
            onChange={(e) => handleFieldChange("orderNo", e.target.value)}
          />
        </Grid>

        <Grid item xs={6} sm={6} md={4} lg={3} xl={2}>
          <TextField
            label="Name"
            fullWidth
            size="small"
            name="contact"
            value={headerData?.party?.name || ""}
            onChange={handlePhoneNo}
            onKeyDown={handleEnterOnContact}
            variant="outlined"
          />
        </Grid>
        <Grid item xs={6} sm={8} md={6} lg={4} xl={4}>
          <TextField
            label="Note"
            fullWidth
            size="small"
            name="note"
            value={headerData.note}
            variant="outlined"
            onChange={(e) => handleFieldChange("note", e.target.value)}
          />
        </Grid>
              <Grid item xs={6} sm={6} md={2} lg={1} xl={1}>
          <TextField
            label="Delivery days"
            fullWidth
            type="number"
            size="small"
            name="delivery_days"
            value={headerData.delivery_days}
            variant="outlined"
            onChange={(e) =>{ 
              handleFieldChange("delivery_days", e.target.value)
              const curdate=dayjs(headerData.date)
              if(parseInt(e.target.value || null)){
                const addeddate=curdate.add(parseInt(e.target.value), 'day')
                handleDelDateChange(addeddate)
              }else{
                handleDelDateChange(curdate)
              }

            
            }}
          />
        </Grid>
        <Grid item xs={6} sm={6} md={3} lg={2} xl={1}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              label="Delivery Date"
              format="DD/MM/YYYY"
              onChange={(value) => {
                
                handleDelDateChange(value)
                const dif=dayjs(value).diff(headerData.date, 'day')
                handleFieldChange("delivery_days", parseFloat(dif))
              }}
              value={headerData.deliveryDate ? dayjs(headerData.deliveryDate):dayjs()}
              slotProps={{
                textField: {
                  size: "small",
                  fullWidth: true,
                },
              }}
              renderInput={(params) => <TextField {...params} size="small" />}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={6} sm={6} md={3} lg={2} xl={1}>
          <Button variant="contained" sx={{background:'#01a3b6'}} onClick={handleDialogOpen}>
            Old Bills
          </Button>
        </Grid>
        <Grid item xs={6} sm={6} md={3} lg={1}>
          <Chip
            label={`Balance qty : ${headerData?.party?.plan_items_left || 0}`}
            color="info"
          />
          {/* <Button variant="contained" onClick={handleDialogOpen}>
            Old Bills
          </Button> */}
        </Grid>
        <Grid item xs={6} sm={3} md={2} lg={2}>
          <Chip
            label={`Plan Expiry : ${
              headerData?.party?.plan_end_date
                ? dayjs(headerData?.party?.plan_end_date).format("DD/MM/YYYY")
                : ""
            }`}
            color="info"
          />
        </Grid>
      </Grid>
    </>
  );
}

export default Header;

Header.propTypes = {
  toDefault: PropTypes.number,
};
